import React, { useState, useEffect } from "react";
import { ReactComponent as ClockIcon } from "./../assets/clock.svg";
import {
  DESCRIPTION_COLOR,
  HEADER_COLOR,
  PRIMARY_COLOR,
  TERTIARY_COLOR,
} from "../constants/theme";
import { toast } from "react-toastify";
import moment from "moment";
import {
  getDrScheduleByPatientIdAndDateRange,
  getScheduleById,
} from "../services/drSchedule/drSchedule.service";
import { useNavigate } from "react-router";
import Loader from "../components/Loader";
import { getClinicByCode } from "../services/clinic/clinic.service";

const AppointmentView = () => {
  const email = sessionStorage.getItem("email");
  const patientId = sessionStorage.getItem("patientId");
  const clinicCode = sessionStorage.getItem("clinicCode")
    ? JSON.parse(sessionStorage.getItem("clinicCode"))[0]?.clinic_code
    : "";
  const selectedAppointmentId = sessionStorage.getItem("appointmentId");
  const [appointmentDataLoading, setAppointmentDataLoading] = useState(false);
  const [appointmentHistoryLoading, setAppointmentHistoryLoading] =
    useState(false);
  const [allAppointments, setAllAppointments] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(undefined);
  const [screenWidth, setScreenWidth] = useState(0);
  let startDate = moment("2000-01-01").format("YYYY-MM-DD");
  const [endDate, setEndDate] = useState(undefined);
  const [clinicLoading, setClinicLoading] = useState(false);
  const [clinicData, setClinicData] = useState(undefined);

  const navigate = useNavigate();

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const getClinicDetails = async () => {
    try {
      setClinicLoading(true);
      const res = await getClinicByCode(email, clinicCode);
      if (res.status === 200 && res.data.status === 200) {
        setClinicData(res.data.data);
        setClinicLoading(false);
      } else {
        setClinicData(undefined);
        setClinicLoading(false);
      }
    } catch (error) {
      console.log("Error fetching clinic info => ", error);
      setClinicData(undefined);
      setClinicLoading(false);
    }
  };

  const getAppointmentDetails = async () => {
    try {
      setAppointmentDataLoading(true);
      const res = await getScheduleById(email, selectedAppointmentId);

      if (res.status === 200 && res.data.status === 200) {
        setSelectedAppointment(res.data.data);
        setEndDate(res.data.data.date);
        setAppointmentDataLoading(false);
      } else {
        toast.error(res?.data?.message || res?.message);
        setSelectedAppointment(undefined);
        setEndDate(undefined);
        setAppointmentDataLoading(false);
      }
    } catch (error) {
      toast.error("Error fetching appointment data. Try again later!");
      console.log("Error fetching appointment details => ", error);
      setSelectedAppointment(undefined);
      setEndDate(undefined);
      setAppointmentDataLoading(false);
    }
  };

  const fetchAppointmentHistory = async () => {
    try {
      setAppointmentHistoryLoading(true);

      const res = await getDrScheduleByPatientIdAndDateRange(
        email,
        patientId,
        startDate,
        endDate
      );
      if (res.status === 200 && res.data.status === 200) {
        setAllAppointments(res.data.data);
        setAppointmentHistoryLoading(false);
      }
    } catch (error) {
      console.log("Error fetching appointment history => ", error);

      setAllAppointments([]);
      setAppointmentHistoryLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedAppointmentId && !sessionStorage.getItem("appointmentId")) {
      navigate("/home-screen");
    }
    getClinicDetails();
    getAppointmentDetails();
  }, []);

  useEffect(() => {
    if (endDate) {
      fetchAppointmentHistory();
    }
  }, [endDate]);

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        // backgroundColor: "#fae5ff",
      }}
    >
      <div
        className="position-relative"
        style={{
          minHeight: "100vh",
          zIndex: "20",
          padding: "2px 15px 10px 15px",
        }}
      >
        <div
          className="row w-100 mx-auto flex-column align-items-center justify-content-start"
          style={{
            gap: "15px",
          }}
        >
          <div
            className="row w-100 mx-auto flex-column align-items-center justify-content-start p-0"
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "15px",
            }}
          >
            {/* <h4
              className="text-center p-0 mt-2"
              style={{
                color: HEADER_COLOR,
              }}
            >
              Appointment View
            </h4>

            <hr /> */}

            {appointmentDataLoading && (
              <div style={{ minHeight: "40vh" }}>
                <Loader />
              </div>
            )}

            {!appointmentDataLoading && !selectedAppointment && (
              <div style={{ minHeight: "40vh" }}>
                <h6>Appointment data not found!</h6>
              </div>
            )}

            {!appointmentDataLoading && selectedAppointment && (
              <>
                {/* <div
                  className="w-100 position-relative"
                  style={{
                    minHeight: "180px",
                    borderTopRightRadius: "15px",
                    borderTopLeftRadius: "15px",
                    backgroundColor: "rgb(110, 121, 125)",
                  }}
                >
                  <div
                    className="position-absolute"
                    style={{
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      // background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6) 10%, rgba(255,255,255,0) 20%, rgba(255,255,255,0) 100%)',
                    }}
                  ></div>
                </div> */}

                <div
                  className=""
                  style={{
                    // backgroundColor: 'rgb(255, 255, 255)',
                    padding: "16px 13px 14px 13px",
                    borderBottomLeftRadius: "15px",
                    borderBottomRightRadius: "15px",
                  }}
                >
                  <div
                    className="row w-100 mx-auto flex-column justify-content-start align-items-center"
                    style={{
                      gap: "25px",
                    }}
                  >
                    {/*  */}

                    <div className="col-12 p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          lineHeight: "1",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          gap: "9px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className=""
                            style={{
                              color: DESCRIPTION_COLOR,
                            }}
                          >
                            Date
                          </div>
                        </div>
                        <div className="col-auto p-0">
                          <div
                            className="d-flex flex-column align-items-center justify-content-center"
                            style={{
                              gap: "6px",
                            }}
                          >
                            <div
                              className=""
                              style={{
                                fontSize: "17px",
                                color: PRIMARY_COLOR,
                              }}
                            >
                              {moment(selectedAppointment?.date).format("dddd")}
                              ,{" "}
                              {moment(selectedAppointment?.date).format(
                                "DD-MMM-YY"
                              )}
                            </div>

                            <div
                              className=""
                              style={{
                                color: DESCRIPTION_COLOR,
                              }}
                            >
                              {selectedAppointment?.start_time_clock} -{" "}
                              {selectedAppointment?.end_time_clock}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*  */}

                    <div className="col-12 p-0">
                      <div
                        className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                        style={{
                          lineHeight: "1",
                          fontWeight: "normal",
                          fontSize: "12.5px",
                          gap: "5px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <div
                            className=""
                            style={{
                              color: DESCRIPTION_COLOR,
                            }}
                          >
                            Service
                          </div>
                        </div>
                        <div className="col-auto p-0">
                          <div
                            className=""
                            style={{
                              fontSize: "17px",
                              color: PRIMARY_COLOR,
                            }}
                          >
                            {selectedAppointment?.service_type}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*  */}
                    {/* <div className="col-12 p-0">
                  <div
                    className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                    style={{
                      lineHeight: "1",
                      fontWeight: "normal",
                      fontSize: "12.5px",
                      gap: "5px",
                    }}
                  >
                    <div className="col-auto p-0">
                      <div
                        className=""
                        style={{
                          color: DESCRIPTION_COLOR,
                        }}
                      >
                        Stage
                      </div>
                    </div>
                    <div className="col-auto p-0">
                      <div
                        className=""
                        style={{
                          fontSize: "17px",
                          color: PRIMARY_COLOR,
                        }}
                      >
                        Stage-1
                      </div>
                    </div>
                  </div>
                </div> */}

                    {/*  */}

                    <div
                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                      style={{
                        lineHeight: "1",
                        fontWeight: "normal",
                        fontSize: "12.5px",
                        gap: "5px",
                      }}
                    >
                      {!clinicLoading && clinicData && (
                        <>
                          <div className="col-auto p-0">
                            <div
                              className=""
                              style={{
                                color: DESCRIPTION_COLOR,
                              }}
                            >
                              Appointment with
                            </div>
                          </div>
                          <div className="col-auto p-0">
                            <div
                              className=""
                              style={{
                                fontSize: "17px",
                                color: PRIMARY_COLOR,
                              }}
                            >
                              {
                                clinicData?.doctors?.find(
                                  (item) =>
                                    item?.doctor_email ===
                                      selectedAppointment?.doctor_id ||
                                    item?.email ===
                                      selectedAppointment?.doctor_id
                                )?.name
                              }
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {/*  */}
                    <div className="col-12 p-0">
                      <div className="row w-100 mx-auto align-items-center justify-content-center">
                        <div className="col-auto p-0">
                          <div
                            className="row w-100 mx-auto align-items-center justify-content-center"
                            style={{
                              gap: "9px",
                            }}
                          >
                            {/* <div className="col-auto p-0">
                              <button
                                className="btn"
                                style={{
                                  border: "none",
                                  backgroundColor: TERTIARY_COLOR,
                                  color: PRIMARY_COLOR,
                                  fontWeight: "400",
                                  fontSize: "10.5px",
                                  borderRadius: "20px",
                                  minWidth: "120px",
                                  padding: "8px 4px",
                                  lineHeight: "1",
                                }}
                              >
                                Reschedule
                              </button>
                            </div> */}

                            <button
                              className="btn"
                              style={{
                                border: "none",
                                backgroundColor: TERTIARY_COLOR,
                                color: PRIMARY_COLOR,
                                fontWeight: "400",
                                fontSize: "12px",
                                borderRadius: "20px",
                                minWidth: "120px",
                                padding: "8px 4px",
                                lineHeight: "1",
                              }}
                              onClick={() => navigate("/appointment")}
                            >
                              + Appointment
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div
            className="row w-100 mx-auto align-items-center justify-content-start"
            style={{
              gap: "20px",
              minHeight: "70px",
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "15px",
              padding: "16px",
            }}
          >
            <div
              className="text-center"
              style={{
                fontSize: "12px",
                color: DESCRIPTION_COLOR,
                fontWeight: "normal",
                lineHeight: "1",
              }}
            >
              Appointments History
            </div>

            <hr className="m-0 mx-auto" />

            {appointmentHistoryLoading && <Loader />}

            {!appointmentHistoryLoading &&
              (!allAppointments || allAppointments.length === 0) && (
                <h6>No appointment history!</h6>
              )}

            {!appointmentHistoryLoading &&
              allAppointments &&
              allAppointments.length > 0 &&
              allAppointments.map((item) => (
                <>
                  <div
                    className="row w-100 align-items-center justify-content-center"
                    key={item.id}
                  >
                    <div
                      className={`${
                        screenWidth > 620 ? "col-8" : "col-auto"
                      } p-0`}
                    >
                      <div
                        className={`row w-100 mx-auto align-items-center justify-content-${
                          screenWidth > 620 ? "between" : "start"
                        }`}
                        style={{
                          gap: screenWidth >= 576 ? "16px" : "7px",
                          flexWrap: "nowrap",
                        }}
                      >
                        <div className="d-flex col-auto p-0 gap-2">
                          <div className="col-auto p-0">
                            <div
                              className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                              style={{
                                gap: "6px",
                              }}
                            >
                              <div className="col-auto p-0">
                                <div
                                  className=""
                                  style={{
                                    width: "37px",
                                  }}
                                >
                                  <ClockIcon
                                    style={{
                                      overflow: "visible",
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-auto p-0">
                                <div
                                  className=""
                                  style={{
                                    lineHeight: "1",
                                    fontSize: "10px",
                                    color: DESCRIPTION_COLOR,
                                    fontWeight: "normal",
                                  }}
                                >
                                  {item.start_time_clock}
                                </div>
                                <div
                                  className="text-center"
                                  style={{
                                    lineHeight: "1",
                                    fontSize: "10px",
                                    color: DESCRIPTION_COLOR,
                                    fontWeight: "normal",
                                  }}
                                >
                                  to
                                </div>
                                <div
                                  className=""
                                  style={{
                                    lineHeight: "1",
                                    fontSize: "10px",
                                    color: DESCRIPTION_COLOR,
                                    fontWeight: "normal",
                                  }}
                                >
                                  {item.end_time_clock}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                            style={{
                              lineHeight: "1",
                              minWidth: "45px",
                            }}
                          >
                            <div className="col-auto p-0">
                              <div
                                className=""
                                style={{
                                  fontSize: "22px",
                                  color: PRIMARY_COLOR,
                                  fontWeight: "normal",
                                }}
                              >
                                {moment(item.date).format("DD")}
                              </div>
                            </div>
                            <div
                              className="col-auto p-0"
                              style={{
                                marginTop: "2.5px",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "14.5px",
                                  color: "#000000",
                                  fontWeight: "normal",
                                }}
                              >
                                {moment(item.date).format("MMM")}
                              </div>
                            </div>
                            <div
                              className="col-auto p-0"
                              style={{
                                marginTop: "1px",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "10px",
                                  color: DESCRIPTION_COLOR,
                                  fontWeight: "normal",
                                }}
                              >
                                {moment(item.date).format("YYYY")}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row w-100 mx-auto flex-row align-items-center justify-content-center">
                          <div
                            className=""
                            style={{
                              lineHeight: "1",
                              gap: "0.5px",
                            }}
                          >
                            <div
                              className=""
                              style={{
                                fontSize: "12px",
                                color: DESCRIPTION_COLOR,
                              }}
                            >
                              Service
                            </div>

                            <div
                              className=""
                              style={{
                                fontSize: "13px",
                                color: PRIMARY_COLOR,
                                minWidth: "125px",
                                maxWidth: "150px",
                              }}
                            >
                              {item?.service_type}
                            </div>
                          </div>

                          {!clinicLoading && clinicData && (
                            <div
                              className="mt-2"
                              style={{
                                lineHeight: "1",
                                gap: "0.5px",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  fontSize: "12px",
                                  color: DESCRIPTION_COLOR,
                                }}
                              >
                                Doctor
                              </div>

                              <div
                                className=""
                                style={{
                                  fontSize: "13px",
                                  color: PRIMARY_COLOR,
                                  minWidth: "125px",
                                  maxWidth: "150px",
                                }}
                              >
                                {
                                  clinicData?.doctors?.find(
                                    (item) =>
                                      item?.doctor_email ===
                                        selectedAppointment?.doctor_id ||
                                      item?.email ===
                                        selectedAppointment?.doctor_id
                                  )?.name
                                }
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr
                    key={item.schedule_id}
                    className="m-0 mx-auto"
                    style={{
                      width: "100%",
                      maxWidth: screenWidth >= 576 ? "400px" : "300px",
                    }}
                  />
                </>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentView;
